import { render, staticRenderFns } from "./govdisco.vue?vue&type=template&id=a7bbb2c4"
import script from "./govdisco.vue?vue&type=script&lang=js"
export * from "./govdisco.vue?vue&type=script&lang=js"
import style0 from "./govdisco.vue?vue&type=style&index=0&id=a7bbb2c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports